export const TRANSLATION_SCOPE = 'questionnaireGridModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
